var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.modalDocumentViewIsOpen
        ? _c("visualizar-documentos", {
            attrs: { documentos: [_vm.documentView] },
            on: { closeModal: _vm.closeDocumentViewModal }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mt-20px" }, [
        _c(
          "div",
          { staticClass: "padding-right-30px" },
          [
            _c("upload-resumable", {
              attrs: {
                id: _vm.id,
                fileTypes: _vm.fileTypes,
                required: _vm.ruleRequired
              },
              on: { uploadFile: _vm.uploadFile }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.files.length
          ? _c(
              "div",
              { staticClass: "mt-20px" },
              [
                _vm.listLabel
                  ? _c("Label", {
                      attrs: {
                        label: _vm.listLabel,
                        obrigatorio: _vm.isRequired
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-table",
                  { attrs: { data: _vm.files } },
                  [
                    _c("el-table-column", {
                      attrs: { label: "Nome do Arquivo:", prop: "nome" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { width: "120" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "flex-center" },
                                  [
                                    _vm.showDocumentView
                                      ? _c("app-action-button", {
                                          attrs: {
                                            icone: "eye",
                                            cor: !_vm.documentHasView(scope.row)
                                              ? "#C0C4CC"
                                              : "#666666",
                                            text: !_vm.documentHasView(
                                              scope.row
                                            )
                                              ? "Não é possível exibir esse arquivo"
                                              : "Visualizar Documento",
                                            disabled: !_vm.documentHasView(
                                              scope.row
                                            )
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.viewDocument(scope.row)
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.showDownload
                                      ? _c("app-action-button", {
                                          attrs: {
                                            icone: "download",
                                            cor: "#666666",
                                            text: "Baixar Documento"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.getDownload(scope.row)
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.showDelete
                                      ? _c("app-action-button", {
                                          attrs: {
                                            icone: "trash",
                                            cor: "#666666",
                                            text: "Remover Documento"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeFile(scope.row)
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2188104605
                      )
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d920e7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d920e7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Forms/DocumentUpload/DocumentUpload.vue
// module id = null
// module chunks = 